import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import {connect} from 'react-redux';
import Wrapper from "./Wrapper";
import ActionSpinner from "../common/ActionSpinner";
import Progress from "../common/Progress";
import Footer from "../common/Footer";
import Navigation from "../common/Navigation/Navigation";
import history from "../../config/history";
import Utils from "../../Utils";
import {getApplicationLocale} from "../../reducers/auth";

class Main extends React.Component<RouteComponentProps> {

    UNSAFE_componentWillMount(): void {
        if (this.props.location.hash.includes("#")) {
            history.replace(this.props.location.pathname + this.props.location.hash.replace("#/", ""));
        }
        const locale: { label: string, value: string } = getApplicationLocale();
        Utils.updateLocaleFormat("en", locale.value);
    }

    UNSAFE_componentWillReceiveProps(nextProps: Readonly<any>, nextContext: any): void {
        if (JSON.stringify(nextProps.location) !== JSON.stringify(this.props.location)) {
            nextProps.location["prevLocation"] = this.props.location
        }
    }

    render() {
        return (
            <div>
                <Wrapper>
                    <div id="wrapper">
                        <Progress/>
                        <Navigation/>
                        <div id="page-wrapper" className={"gray-bg"}>
                            <div style={{height: "calc(100vh - 36px)", overflowY: "auto"}}>
                                {this.props.children}
                            </div>
                            <Footer/>
                        </div>
                    </div>
                </Wrapper>
                <ActionSpinner/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = () => {
    return {}
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main))



// WEBPACK FOOTER //
// ./app/components/layouts/Main.tsx